module.exports = __webpack_public_path__ + "media/images/pages/commercial/pocstock-commercial-3-9c9c07b170c1fdc36a5c39aa4d254531.png";